/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Tutorial_PanInputs */

const en_camera_tutorial_pan = /** @type {(inputs: Camera_Tutorial_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right click · pan`)
};

const fr_camera_tutorial_pan = /** @type {(inputs: Camera_Tutorial_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clic droit · déplacement`)
};

const ms_sg2_camera_tutorial_pan = /** @type {(inputs: Camera_Tutorial_PanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik kanan · alih`)
};

/**
* | output |
* | --- |
* | "Right click · pan" |
*
* @param {Camera_Tutorial_PanInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const camera_tutorial_pan = /** @type {((inputs?: Camera_Tutorial_PanInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Tutorial_PanInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_tutorial_pan(inputs)
	if (locale === "fr") return fr_camera_tutorial_pan(inputs)
	return ms_sg2_camera_tutorial_pan(inputs)
});